module.exports = __webpack_public_path__ + "img/sweden-colorectal-cancer-male.49a13bbf.png";